import moment from 'moment';

function WidgetUserMap(item) {
	const dt = moment().format('YYYY-MM-DD HH:mm:ss');

	this.widgetKey = item.widgetKey;
	this.widgetTitle = item.widgetTitle;
	this.useYn = item.useYn;
	this.x = Number(item.x);
	this.y = Number(item.y);
	this.minW = Number(item.minW || 1);
	this.minH = Number(item.minH || 1);
	// console.log(item, item.w, item.minW, Number(item.minW));
	this.width = Math.max(Number(item.w), this.minW);
	this.height = Math.max(Number(item.h), this.minH);
	this.seq = Number(item.i);
	item.para = item.para || item.parameter || {};
	this.para = _.isString(item.para) ? item.para : JSON.stringify(item.para);
	this.parameter = this.para;
	this.regDt = item.regDt || dt;
	this.chgDt = dt;
	// console.log('Component -> WidgetUserMap', item, this);

	return this;
}

WidgetUserMap.prototype.equals = function (item) {
	return (
		this.x === item.x &&
		this.y === item.y &&
		this.width === item.w &&
		this.height === item.h &&
		this.seq === item.i &&
		this.widgetTitle === item.widgetTitle
	);
};

export default WidgetUserMap;
